import { useState } from 'react'
import { FaSearch, FaPlus, FaTrash, FaCheck, FaSpinner } from 'react-icons/fa'
import './ButtonDemo.css'

function ButtonDemo() {
  const [loading, setLoading] = useState(false)

  const handleLoadingClick = () => {
    setLoading(true)
    setTimeout(() => setLoading(false), 2000)
  }

  return (
    <div className="button-demo">
      <section className="demo-section">
        <h4>按钮类型</h4>
        <div className="button-row">
          <button className="btn btn-primary">主要按钮</button>
          <button className="btn btn-secondary">次要按钮</button>
          <button className="btn btn-success">成功按钮</button>
          <button className="btn btn-warning">警告按钮</button>
          <button className="btn btn-error">错误按钮</button>
        </div>
      </section>

      <section className="demo-section">
        <h4>按钮尺寸</h4>
        <div className="button-row">
          <button className="btn btn-primary btn-small">小按钮</button>
          <button className="btn btn-primary">默认按钮</button>
          <button className="btn btn-primary btn-large">大按钮</button>
        </div>
      </section>

      <section className="demo-section">
        <h4>带图标的按钮</h4>
        <div className="button-row">
          <button className="btn btn-primary">
            <FaSearch /> 搜索
          </button>
          <button className="btn btn-success">
            <FaPlus /> 添加
          </button>
          <button className="btn btn-error">
            <FaTrash /> 删除
          </button>
          <button className="btn btn-primary" onClick={handleLoadingClick} disabled={loading}>
            {loading ? <><FaSpinner className="spin" /> 加载中...</> : <><FaCheck /> 确认</>}
          </button>
        </div>
      </section>

      <section className="demo-section">
        <h4>按钮状态</h4>
        <div className="button-row">
          <button className="btn btn-primary">正常状态</button>
          <button className="btn btn-primary" disabled>禁用状态</button>
          <button className="btn btn-primary loading">
            <FaSpinner className="spin" /> 加载中
          </button>
        </div>
      </section>

      <section className="demo-section">
        <h4>块级按钮</h4>
        <div className="button-column">
          <button className="btn btn-primary btn-block">块级主要按钮</button>
          <button className="btn btn-secondary btn-block">块级次要按钮</button>
        </div>
      </section>
    </div>
  )
}

export default ButtonDemo